import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationComponent } from '@app/shared/components';
import { NOTIFICATION_CONFIGS, NotificationType } from './notification.types';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private dialog = inject(MatDialog);

  async showNotification(
    type: NotificationType,
    customMessage?: string,
    customImageUrl?: string,
    customAutoClose: number = 3000
  ): Promise<void> {
    const config = NOTIFICATION_CONFIGS[type];

    if (!config) {
      console.error(`Tipo de notificación '${type}' no encontrado.`);
      return;
    }

    const dialogRef = this.dialog.open(NotificationComponent, {
      width: '380px',
      panelClass: 'notification-modal-class',
      data: {
        message: customMessage || config.message,
        imageUrl: customImageUrl || config.imageUrl,
      },
      disableClose: true
    });

    return new Promise((resolve) => {
      setTimeout(() => {
        dialogRef.close();
        resolve();
      }, customAutoClose);
    });
  }
}
